import React, {useState, useEffect} from "react";
import "./../../utils/Style/pages/Employees.scss";
import {FormErrors} from './FormErrors';
import {useDispatch, useSelector} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useOutletContext} from "react-router-dom";
import useCommonAPI from "../../api/CommonAPI";
import {setFlag} from "../../features/responseSlice";
import {capitalizeFirstLetters} from "../../features/ValueFormater";


function NewEmployee({setActiveButton}) {

    const dispatch = useDispatch();
    const [onOpenQrAfterGenerate] = useOutletContext();

    const [phoneNumber, setPhoneNumber] = useState('');
    const [formErrors, setFormErrors] = useState({email: '', password: ''});
    const [position, setPosition] = useState(null);
    const [showInfo, setShowInfo] = useState(false);
    const [errors, setErrors] = useState({});
    const [rolesToIterate, setRolesToIterate] = useState([]);

    const entityType = sessionStorage.getItem("EntityType");

    const {getAllEmployeesRoles, roles} = useCommonAPI();
    const {flag} = useSelector((state) => state.transferResponse);

    useEffect(() => {
        if ([0, 1].includes(flag)){
            dispatch(setFlag(null));
            setActiveButton({name: "Employees"});
        }

    }, [flag])


    useEffect(() => {
        getAllEmployeesRoles();
    }, [])

    useEffect(() => {
        if (roles) {
            if (entityType === "LEGALENTITY") {
                setRolesToIterate(roles?.find(role => role.Type === "Legal")?.Roles);
            } else {
                setRolesToIterate(roles?.find(role => role.Type === "Merchant")
                    .Roles.filter(role => role.Name.toLowerCase() === "admin"));
            }
        }

    }, [roles]);

    const handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        switch (name) {
            case 'phoneNumber':
                setPhoneNumber(value);
                setErrors({...errors, ["phoneNumber"]: ""});
                break;
            default:
                break;
        }
    };
    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!position || position === "-1") {
            newErrors.position = "Access Level is required.";
            isValid = false;
        }

        if (!phoneNumber) {
            newErrors.phoneNumber = "Phone Number is required.";
            isValid = false;
        }
        const regex = /^\+?\d{7,}$/
        if (phoneNumber && !regex.test(phoneNumber)) {
            newErrors.phoneNumber = "Phone Number format is incorrect.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            const payload = {
                RoleID: position,
                MobileNo: phoneNumber
            }

            if (entityType === "LEGALENTITY") {
                dispatch(setActionType(ACTION_TYPES.ADD_LEGAL_EMPLOYEE));
            } else {
                dispatch(setActionType(ACTION_TYPES.ADD_EMPLOYEE));
            }
            dispatch(setActionPayload(payload));
            onOpenQrAfterGenerate();
        }
    }

    return (
        <>
            <div className="NewEmployeeTemplate">
                <div className="title">ADD EMPLOYEE ACCESS</div>
                <div className="row phone mt-3">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row component">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Phone Number</div>
                            <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                <input
                                    placeholder="Xxxx"
                                    type="text"
                                    required
                                    name="phoneNumber"
                                    value={phoneNumber}
                                    onChange={handleUserInput}
                                />
                                {errors.phoneNumber && (
                                    <span className="error">{errors.phoneNumber}</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row component mt-5">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="col-lg-12 subTitle">
                            Access
                            {
                                entityType === "LEGALENTITY" &&
                                <button className="info-Img"
                                        onClick={() => {
                                            setShowInfo(!showInfo);
                                        }
                                        }>
                                    {
                                        showInfo ? (
                                            <img className="" src="/Images/info-fill.png"/>
                                        ) : (
                                            <img src="/Images/info.png"/>
                                        )
                                    }
                                </button>
                            }
                        </div>
                        <div className="col-lg-12 desc">
                            <select
                                className="ddselect"
                                name="account"
                                onChange={(e) => {
                                    setPosition(e.target.value);
                                    setErrors({...errors, ["position"]: ""});
                                }}
                            >
                                <option value={-1}>Select the Access Level</option>
                                {
                                    rolesToIterate.map(({Name, Id}) => (
                                        <option key={Id} value={Id}>{capitalizeFirstLetters(Name)}</option>
                                    ))
                                }


                            </select>
                            {errors.position && (
                                <span className="error">{errors.position}</span>
                            )}
                        </div>
                        <div className="col-lg-12 desc">
                            <button className="submit" onClick={() => handleSubmit()}>Submit</button>
                        </div>
                    </div>
                    {
                        showInfo ? (
                            <div className="col-lg-6 col-md-12 col-sm-12 info-text">
                                <div className="row AccessDes">
                                    <div className="Title">Viewer:</div>
                                    <div className="p">The viewer role allows the employee to view & download transactions, statements
                                        of accounts & reports.</div>
                                    <div className="Title">Admin:</div>
                                    <div className="p">The admin role allows the employee to:</div>
                                    <div className="p">- View & download transactions, statements of accounts & reports.</div>
                                    <div className="p">- Initiate any type of transaction - based n pre-set limits (per transaction &
                                        per month)</div>
                                    <div className="p">- Approve any type of transaction initiated by other admins or super-admins when
                                        the amount of the transaction exceeds the pre-set limit</div>
                                    <p></p>
                                    <div className="Title">Super Admin:</div>
                                    <div className="p">The super admin role allows the employee to:</div>
                                    <div className="p">- View & download transactions, statements of accounts & reports.</div>
                                    <div className="p">- Initiate any type of transaction - based n pre-set limits (per transaction &
                                        per month)</div>
                                    <div className="p">- Approve any type of transaction initiated by other admins or super-admins when
                                        the amount of the transaction exceeds the pre-set limit</div>
                                    <div className="p">- Add & manage the Legal entity employees</div>
                                </div>
                            </div>
                        ) : (<></>)
                    }
                </div>
                {/*</form>*/}
            </div>
        </>
    );
}

export default NewEmployee;